import { defineStore } from 'pinia';

export const useIframeModalStore = defineStore('iframeModalStore', {
  state() {
    return {
      showIframeModal: false,
      iframeUrl: '',
      iframeModalPopUpDetails: null,
    };
  },
  actions: {
    // Set the iframe popup modal data upon clicking on link where link contain #modal-[modelName]'
    setIframeModalPopUpDetails(payload) {
      this.iframeModalPopUpDetails = payload;
    },
  },
});
